import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/issueInvoice', request)
}

export {post}
